import React from "react"

export type AIChatMessageContextValue = {
  /** All image URLs found in the current AI chat message body, in order. */
  imageUrls: string[]
}

export const AIChatMessageContext =
  React.createContext<AIChatMessageContextValue>({
    imageUrls: [],
  })

const MARKDOWN_LINK_RE = /\[[^\]]*\]\(([^)]+)\)/g
const IMAGE_RE = /\.(gif|png|jpe?g|webp)(\?|#|$)/i

/** Extract image URLs from markdown `[text](url)` links. */
export function extractImageUrlsFromMarkdown(markdown: string): string[] {
  const urls: string[] = []
  const seen = new Set<string>()
  let match: RegExpExecArray | null
  MARKDOWN_LINK_RE.lastIndex = 0
  while ((match = MARKDOWN_LINK_RE.exec(markdown)) !== null) {
    const url = match[1].trim()
    if (!seen.has(url) && IMAGE_RE.test(url)) {
      seen.add(url)
      urls.push(url)
    }
  }
  return urls
}
